import React from 'react';
import { Star, Quote } from 'lucide-react';
import { useContent } from '../i18n/LanguageContext';
import TESTIMONIALS from '../data/testimonials';

function reviewSchema(items) {
  const avg = items.reduce((s, t) => s + t.rating, 0) / items.length;
  return {
    '@context': 'https://schema.org', '@type': 'Organization', name: 'LOGITAG', url: 'https://logitag.ch/',
    aggregateRating: { '@type': 'AggregateRating', ratingValue: avg.toFixed(1), reviewCount: items.length, bestRating: 5 },
    review: items.map((t) => ({
      '@type': 'Review', reviewBody: t.quote, datePublished: t.date,
      author: { '@type': 'Person', name: t.author },
      reviewRating: { '@type': 'Rating', ratingValue: t.rating, bestRating: 5 },
    })),
  };
}

export default function Testimonials() {
  const c = useContent();
  const s = c.testimonials;
  const items = TESTIMONIALS.filter((t) => !t.lang || t.lang === c.lang);
  if (!TESTIMONIALS.length) return null;

  return (
    <section id="temoignages" className="py-14 md:py-20 bg-slate-50" data-testid="testimonials">
      <script type="application/ld+json">{JSON.stringify(reviewSchema(TESTIMONIALS))}</script>
      <div className="lt-container">
        <div className="max-w-3xl reveal">
          <p className="text-sm font-semibold uppercase tracking-widest text-teal-600">{s.eyebrow}</p>
          <h2 className="mt-3 font-display text-3xl md:text-4xl font-bold text-slate-900 leading-tight">{s.title}</h2>
          <p className="mt-4 text-lg text-slate-600">{s.subtitle}</p>
        </div>
        <div className="mt-12 grid md:grid-cols-3 gap-6">
          {(items.length ? items : TESTIMONIALS).map((t, i) => (
            <figure key={i} data-testid={`testimonial-${i}`} className="reveal card-hover rounded-2xl border border-slate-200 bg-white p-7 flex flex-col" style={{ animationDelay: `${i * 90}ms` }}>
              <div className="flex items-center justify-between">
                <Quote className="w-8 h-8 text-teal-200" />
                <span className="inline-flex gap-0.5" aria-label={`${t.rating}/5`}>
                  {[1, 2, 3, 4, 5].map((n) => <Star key={n} className={`w-4 h-4 ${n <= t.rating ? 'fill-amber-400 text-amber-400' : 'text-slate-200'}`} />)}
                </span>
              </div>
              <blockquote className="mt-4 text-slate-700 leading-relaxed flex-1">“{t.quote}”</blockquote>
              <figcaption className="mt-6 pt-4 border-t border-slate-100">
                <p className="font-semibold text-slate-900">{t.author}</p>
                <p className="text-sm text-slate-500">{[t.role, t.company].filter(Boolean).join(' · ')}</p>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}
